import {applyMiddleware, createStore, type Store} from "redux";
import thunkMiddleware from "redux-thunk";

import {PermissionsInfo} from "@repo/shared-core";
import {createCompose} from "@repo/util-redux-create-compose";

import type {DiscussionContext, DiscussionsServerResponse} from "../types.ts";

import discussionReducer, {
    getDefaultState,
    mergeStateWithNewPosts,
    type Action,
    type State,
} from "./discussion-reducer.ts";

type PromiseAction = Promise<Action>;
type Dispatch = (
    action: Action | ThunkAction | PromiseAction | Array<Action>,
) => any;
type GetState = () => State;
export type ThunkAction = (dispatch: Dispatch, getState: GetState) => void;

const compose = createCompose({
    reduxDevtoolsOptions: {
        name: "Discussions",
    },
});

const createStoreWithMiddleware = compose(
    // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
    applyMiddleware<State, Action, Dispatch>(thunkMiddleware),
    // @ts-expect-error - TS2345 - Argument of type 'StoreCreator' is not assignable to parameter of type 'StoreEnhancerStoreCreator<{}, {}>'.
)(createStore);

export const createDiscussionStore = (
    cachedResult?: DiscussionsServerResponse,
    discussionContext?: DiscussionContext,
    // @ts-expect-error - Type 'ThunkAction' is not assignable to type 'Action<any>'
): Store<State, Action | ThunkAction | PromiseAction | Array<Action>> => {
    // If cachedResult is provided, pre-loads store with list of posts by
    // merging with the default discussion state
    const defaultState = getDefaultState(PermissionsInfo, discussionContext);
    const initialState =
        cachedResult == null
            ? defaultState
            : mergeStateWithNewPosts(
                  defaultState,
                  cachedResult.feedback,
                  defaultState.currentTab,
                  cachedResult.isComplete,
                  cachedResult.totalCount,
                  cachedResult.cursor,
              );
    return createStoreWithMiddleware(discussionReducer, initialState);
};
